import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { PermissionEnum } from '@interfaces';
import { Location } from '@angular/common';

@Component({
  selector: 'cr-button',
  templateUrl: './cr-button.component.html',
  styleUrls: ['./cr-button.component.scss'],
})
export class CrButtonComponent implements OnInit {
  @Input() isLoading = false;
  @Input() isDisabled = false;

  @Input() routerLink: any[] = [];
  @Input() goBack = false;

  @Input() size?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'MEDIUM';
  @Input() fontSize?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'MEDIUM';

  @Input() requiredPermissions?: PermissionEnum[] = [];

  @Output() clicked = new EventEmitter<void>();

  public cssClasses: string[] = [];

  constructor(private readonly location: Location) {}

  public ngOnInit() {
    this.cssClasses = [`SIZE-${this.size}`, `FONT-${this.fontSize}`];
  }

  public onClick(): void {
    if (this.isLoading) {
      return;
    }

    if (this.isDisabled) {
      return;
    }

    if (this.goBack) {
      this.location.back();
      return;
    }

    this.clicked.emit();
  }
}
